import $ from 'jquery';
import Component from '../models/Component';

export default class tabProduct extends Component {
    constructor(element, context) {
        super(element, context);

        $(() => {

          $('.close-video').on('click', function(){
           $('.modal-video').fadeOut();
          });
          
          this.element.on('click', function() {
            $('.modal-video').fadeIn();
          });
        });
    }
}
